// @ts-nocheck
import waitFor from "@insite/client-framework/Common/Utilities/waitFor";
import { executeAwaitableHandlerChain } from "@insite/client-framework/HandlerCreator";
import loadRealTimePricing from "@insite/client-framework/Store/CommonHandlers/LoadRealTimePricing";
import loadProducts from "@insite/client-framework/Store/Data/Products/Handlers/LoadProducts";
import { getProductsDataView } from "@insite/client-framework/Store/Data/Products/ProductsSelectors";
import {
    getProductListDataViewProperty,
    isLoadMore,
} from "@insite/client-framework/Store/Pages/ProductList/ProductListSelectors";
import { replaceInChain } from "@toolkit/Modules/client-framework/HandlerCreator";
import {
    chain,
    DispatchLoadProducts,
    LoadRealTimePrices,
    ParseQueryParameter,
} from "@insite/client-framework/Store/Pages/ProductList/Handlers/DisplayProducts";
import { dispatchProductImpressions } from "@store/Framework/Services/AnalyticsService";

/* Store Custom Code - Start */
import { getCookie } from "@insite/client-framework/Common/Cookies";
import qs from "qs";
/* Store Custom Code - End */

replaceInChain(chain, ParseQueryParameter, props => {
    const { queryString } = props.parameter;
    const queryOptions = queryString?.startsWith("?") ? queryString.substr(1) : (queryString ?? "");
    const parsedQuery = qs.parse(queryOptions) as any; // Bunzl code - Optimizely is typing as any so we're doing this instead of messing with base types
    const splitCommaSeparated = (value?: string | string[] | null) =>
        typeof value === "string" ? value.split(",") : undefined;
    const {
        criteria,
        query,
        page,
        sort,
        includeSuggestions,
        stockedItemsOnly,
        // Bunzl code -->
        inStockRealTime,
        // <-- Bunzl code
        previouslyPurchasedProducts,
        categoryId,
        brandIds,
        productLineIds,
        priceFilters,
        attributeValueIds,
        searchWithinQueries,
    } = parsedQuery;

    const searchQuery = props.parameter.query || query;

    let pageSize = parsedQuery.pageSize;

    if (!pageSize) {
        pageSize = getCookie("ProductList-PageSize");
    }

    const { catalogPage } = props.result;

    props.result.productFilters = {
        query: criteria || searchQuery,
        page: page ? parseInt(page as string, 10) : undefined,
        pageSize: pageSize ? parseInt(pageSize as string, 10) : undefined,
        sort,
        includeSuggestions: includeSuggestions !== undefined ? includeSuggestions === "true" : undefined,
        stockedItemsOnly: stockedItemsOnly !== undefined ? stockedItemsOnly === "true" : undefined,
        // Bunzl code -->
        inStockRealTime: inStockRealTime !== undefined ? inStockRealTime === "true" : undefined,
        // <-- Bunzl code
        previouslyPurchasedProducts:
            previouslyPurchasedProducts !== undefined ? previouslyPurchasedProducts === "true" : undefined,
        pageCategoryId: catalogPage?.categoryId,
        pageBrandId: catalogPage?.brandId || undefined,
        pageProductLineId: catalogPage?.productLineId || undefined,
        categoryId,
        brandIds: splitCommaSeparated(brandIds),
        productLineIds: splitCommaSeparated(productLineIds),
        priceFilters: splitCommaSeparated(priceFilters),
        attributeValueIds: splitCommaSeparated(attributeValueIds),
        searchWithinQueries: splitCommaSeparated(searchWithinQueries),
    };
});
